__turbopack_context__.v({
  "providerButton": "ShareTripButton-module__ynjCjG__providerButton",
  "providerIcon": "ShareTripButton-module__ynjCjG__providerIcon",
  "shareProvider": "ShareTripButton-module__ynjCjG__shareProvider",
  "shareProviders": "ShareTripButton-module__ynjCjG__shareProviders",
});
